import { createTheme } from '@mantine/core';

import { mantine } from '@monorepo/theme';

import ExtendedButton from '../components/shared/Button/Button';
import ExtendedTextInput from '../components/shared/TextInput/TextInput';

const theme = createTheme({
  ...mantine,
  fontFamily: 'Inter, sans-serif',
  components: {
    Button: ExtendedButton,
    TextInput: ExtendedTextInput,
  },
});

export default theme;
